/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableExpansionTemplate } from 'src/app/@amiga-pyme/table-expansion/templates/table-expansion.template';
import { IStock } from 'src/app/pages/inventory/stock/stock.interface';
import { StockService } from 'src/app/pages/inventory/stock/stock.service';
import digemid_parsed from 'src/assets/demo/data/digemid_parsed.json';
import { getTagColor } from '../../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-products-sale',
  templateUrl: './products-sale.component.html',
  providers: [MessageService]
})
export class ProductsSaleComponent extends TableExpansionTemplate {
  selectedActiveIngredient: any;
  filteredActiveIngredients: any[];
  digemidParsedData: any;
  filteredTableData: any[];

  @Input() branchStoreId: number;
  openSideBar = false;
  confirmSettings = {};
  format = {};
  nameFormat = '';
  nameSubFormat = '';
  itemToSideBar = null;
  displayModal = false;
  rowByProduct: any;
  stockSubFormat = 0;
  constructor(
    private serviceStock: StockService,
    private messageService: MessageService
  ) {
    super('', serviceStock);
  }

  ngOnChanges(changes: any) {
    if (changes.branchStoreId) {
      this.branchStoreId = changes.branchStoreId.currentValue;
      this.initSubscriptions$();
    }
  }

  ngOnInit(): void {
    this.digemidParsedData = Object.keys(digemid_parsed);
    this.table.settings = {
      title: 'Productos en Stock',
      columns: [
        { header: 'Código', field: 'productCode' },
        { header: 'Nombre', field: 'productName' },
        { header: 'Codigó de Barras', field: 'productBarCode' },
        { header: 'Concentración', field: 'productRegulatedConcentration' },
        {
          header: 'Tipo de Presentación',
          field: 'productRegulatedPresentation'
        },
        { header: 'Laboratorio', field: 'productRegulatedLaboratory' },
        {
          header: 'Condición',
          field: 'productRegulatedCondition',
          tag: 'tagStatus'
        },
        { header: 'Expiración', field: 'expAt' },
        { header: 'Lote', field: 'lot' }
      ],
      exportData: false,
      child: {
        columnPatent: {
          title: 'productName',
          data: 'format'
        }
      }
    };

    this.tableChild.settings = {
      title: '',
      columns: [
        { header: 'F.V.', field: 'format' },
        { header: 'S.F.V', field: 'subFormat' },
        { header: 'Cnt.S.F.V', field: 'quantitySubFormat' },
        { header: 'Stock', field: 'stock' },
        { header: 'P.V.', field: 'precio', pipe: 'Currency' }
      ],
      filterColumns: false,
      exportData: false
    };

    this.tableChild.actions = [
      {
        name: 'add-product-cart-sale',
        icon: 'pi pi-plus',
        class: 'p-button-rounded p-button-info mr-2',
        pTooltip: 'Agregar Producto'
      },
      {
        name: 'open',
        icon: 'pi pi-inbox',
        class: 'p-button-rounded p-button-warning',
        pTooltip: 'Abrir Presentación'
      }
    ];

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceStock
      .getData$()
      .subscribe((data: IStock[]) => {
        for (const product of data) {
          if (!product.productRegulatedCondition) {
            product.productRegulatedCondition = 'NINGUNA';
          }
        }
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.productRegulatedConditionCode);
          return item;
        });
        this.table.data = data.filter(
          (row) => row.branchStoreId === this.branchStoreId
        );

        this.filteredTableData = [...this.table.data];
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  onReciveActionChild(event: IEventAction): void {
    const { action, data } = event;
    if (action === 'add-product-cart-sale') {
      const noStockForItem =
        data.selectedParent.format[data.selectedChild.format].stock === 0;

      const notInventoriedItem =
        data.selectedParent.format[data.selectedChild.format].stock ===
        undefined;

      const noSalePrice =
        data.selectedParent.format[data.selectedChild.format].precio ===
        undefined;

      const salePriceIsZero =
        data.selectedParent.format[data.selectedChild.format].precio === 0;

      if (notInventoriedItem) {
        this.messageService.add({
          severity: 'warn',
          summary: 'No hay productos en stock',
          detail: 'El formato de producto aún no ha sido inventariado'
        });
        return;
      }

      if (noStockForItem) {
        this.messageService.add({
          severity: 'warn',
          summary: 'No hay productos en stock',
          detail: 'No hay suficientes productos para vender'
        });
        return;
      }

      if (noSalePrice) {
        this.messageService.add({
          severity: 'warn',
          summary: 'No hay precio de venta',
          detail: 'El precio de venta necesita ser definido'
        });
        return;
      }

      if (salePriceIsZero) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Precio de venta inválido',
          detail: 'El precio de venta debe ser mayor a cero'
        });
        return;
      }

      this.itemToSideBar = data;
      this.openSideBar = true;
    }
    if (action === 'open') {
      this.confirmSettings = {
        message: 'Abrir presentacion de venta',
        action: 'open',
        data
      };
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    const childInformation = data.selectedChild;
    const parentInformation = data.selectedParent;
    const quantitySubFormat = childInformation.quantitySubFormat;
    if (quantitySubFormat == null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No hay cantidad de subformato de venta (Cnt.S.F.V)',
        detail:
          'Para descomprimir un producto se debe especificar la cantidad en el campo  (Cnt.S.F.V) '
      });
      return;
    }
    const stockFormat = childInformation.stock;
    this.nameFormat = childInformation.format;
    this.nameSubFormat = childInformation.subFormat;
    if (this.nameSubFormat != null && stockFormat > 0) {
      this.stockSubFormat = parentInformation.format[this.nameSubFormat].stock;
      if (this.stockSubFormat == null) {
        this.stockSubFormat = 0;
      }
      const newstockFormat = stockFormat - 1;
      const newstockSubFormat = this.stockSubFormat + quantitySubFormat;

      this.format = parentInformation.format;
      const newFormat = this.format;
      newFormat[this.nameFormat].stock = newstockFormat;
      newFormat[this.nameSubFormat].stock = newstockSubFormat;

      const id = parentInformation.id;
      this.message = { message: 'Modificando stock de venta' };
      const fieldsToUpdate = {
        format: newFormat
      };
      this.message = await this.serviceStock.update(id, fieldsToUpdate);
    } else {
      this.displayModal = true;
    }
  }

  filterActiveIngredients(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.digemidParsedData.length; i++) {
      const item = this.digemidParsedData[i];
      if (item.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(item);
      }
    }

    this.filteredActiveIngredients = filtered;
  }

  onSelectedActiveIngredient(event: any) {
    this.selectedActiveIngredient = event;
  }

  searchByActiveIngredient() {
    const groupOfAI =
      digemid_parsed[this.selectedActiveIngredient.toUpperCase()];

    this.filteredTableData = this.table.data.filter((product) => {
      for (const element in groupOfAI) {
        this.rowByProduct =
          (product.productName !== null &&
            product.productName
              .toLowerCase()
              .includes(groupOfAI[element].toLowerCase())) ||
          (product.productName !== null &&
            product.productName
              .toLowerCase()
              .includes(this.selectedActiveIngredient.toLowerCase()));
        if (this.rowByProduct) {
          return true;
        }
      }

      return this.rowByProduct;
    });
  }

  clearFilter() {
    this.filteredTableData = [...this.table.data];
    this.selectedActiveIngredient = undefined;
  }
}
